import { createUseStyles } from "react-jss";

/**
 * styles used in the component.
 */
export const LineItemBulkUpdateStyles = createUseStyles({
  fieldStyle: {
   margin: "5px 5px 20px 5px"
  }
});